"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWorkflowApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
/**
 * Workflow API factory (T117) — ports only web's `useGetInstancesByEntityQuery` (a ticket's
 * workflow instances with step executions and approval requests), the one endpoint the mobile
 * Workflow drill-down needs. Distinct from `approvalApi` (User Story 2's separate cross-ticket
 * Approvals inbox) and from web's full `WorkflowService` (workflow-builder CRUD/dimension
 * endpoints, out of scope — nothing in this app authors workflow definitions). See
 * createTicketApi.ts for the shared-package baseQuery-injection pattern.
 */
const createWorkflowApi = (baseQuery) => (0, react_1.createApi)({
    reducerPath: 'workflowApi',
    baseQuery,
    tagTypes: ['WorkflowInstances'],
    endpoints: (builder) => ({
        getInstancesByEntity: builder.query({
            query: (entityId) => ({
                url: 'workflows/instances/by-entity',
                params: { entityId },
            }),
            providesTags: (_result, _error, entityId) => [{ type: 'WorkflowInstances', id: entityId }],
        }),
    }),
});
exports.createWorkflowApi = createWorkflowApi;
